import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE, TIMESTAMP_MULTIPLY} from 'util/constants';

module.exports = {
    createFetchParams: (startDate, filters) => ({
        technology: filters.technology,
        volume:     filters.volumeNAS,
        date:       Math.floor(startDate / TIMESTAMP_MULTIPLY)
    }),
    ...storeModuleFactory({
        name:               'storageOccupancy',
        endpoint:           endpoints.storage.storageOccupancy,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_BIG,
        transformResultsFn: response => {
            if (response.results.length > 0) {
                return {
                    assignedTb: response.results[0].assigned_tb,
                    freeTb:     response.results[0].free_tb,
                    usedTb:     response.results[0].used_tb
                };
            }

            return [];
        }
    })
};



// WEBPACK FOOTER //
// ./src/modules/store/storageOccupancy.js